<div class="ie-wrapper">
	<div class="main-grid" #mainGrid
	[ngStyle]="trackAreaResizerTop > -1 ? {'grid-template-rows': '1fr calc(100% - ' + trackAreaResizerTop + 'px)'} : {}"
	>
		<div class="is-cell sidebar-l-area"
			(mousedown)="activeArea = 'sidebar-left'"
			(mouseup)="activeArea = 'sidebar-left'"
		>
			<portfolio data-cy="ie-portfolio"></portfolio>
		</div>
		<div class="is-cell central-area can-be-active"
			[class.active]="activeArea === 'central-area'"
			(mousedown)="activeArea = 'central-area'"
			(mouseup)="activeArea = 'central-area'"
		>
			<div class="stage-wrapper">
				<stage [gridResizeStartedSubject]="gridResizeStarted" [gridResizeEndedSubject]="gridResizeEnded"></stage>
			</div>
			<widget-bar data-cy="ie-widget-bar"></widget-bar>
			<player-bar data-cy="ie-player-bar" *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'"></player-bar>
		</div>
		<div class="is-cell sidebar-r-area"
			(mousedown)="activeArea = 'sidebar-right'"
			(mouseup)="activeArea = 'sidebar-right'"
		>
			<!-- Sidebar Right -->
			<inspector data-cy="ie-inspector"></inspector>
		</div>
		<div class="is-cell bottombar-area can-be-active"
			[class.active]="activeArea === 'bottom-area'"
			(mousedown)="activeArea = 'bottom-area'"
			(mouseup)="activeArea = 'bottom-area'"
		>
			<timeline data-cy="ie-timeline"></timeline>
		</div>
		<div
		#trackAreaResizer
		bbDrag
		[bbDragContainer]="mainGrid"
		[bbDragAxis]="'y'"
		(bbDragMoved)="trackAreaResizerDragging($event)"
		class="track-area-resizer"
		></div>
	</div>
</div>
